
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "BananoShape",
  props: {
    mouseControlled: {
      type: Boolean,
      required: false,
    },
    loader: {
      type: Boolean,
      required: false,
    },
  },

  setup(props) {
    const rotateX = ref(10); // on X axis
    const rotateY = ref(10); // on Y axis
    const translate3dX = ref(0);
    const translate3dY = ref(0);

    if (props.mouseControlled) {
      onMounted(() => {
        window.addEventListener("mousemove", (e) => {
          rotateY.value = (e.x / window.innerWidth - 0.5) * 40;
          rotateX.value = -1 * (e.y / window.innerHeight - 0.5) * 40;
          translate3dX.value = (e.x / window.innerWidth - 0.5) * 30;
          translate3dY.value = (e.y / window.innerHeight - 0.5) * 40;
        });
      });
    }

    return {
      rotateX,
      rotateY,
      translate3dX,
      translate3dY,
    };
  },
});
